<template>

  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">PTA</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }"><a>Tableau de
                bord</a></router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'pta' }"><a>PTA</a></router-link>
          </li>
        </ol>
      </div>
    </div>



    <div class="row">
      <div class="col-12 col-sm-12" v-if="showList">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-end flex-wrap gap-2">
              <!-- Sélecteur Année -->
              <div>
                <label class="form-label">Année <span class="text-danger">*</span></label>
                <multi-select deselect-label="Sélectionné" select-label="" :options="exercices"
                  @select="loadActionsGrouped" placeholder="sélectionnez" label="annee" track-by="annee"
                  :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.annee }}</strong>
                  </template>
                  <span slot="noOptions"><strong>Liste Vide</strong></span>
                  <span slot="noResult"><strong>Aucun Résultat</strong></span>
                </multi-select>
              </div>
              <div class="mx-auto"></div>

              <!-- Boutons -->
              <router-link :to="{ name: 'generationPta', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Génération PTA</button>
              </router-link>

              <router-link :to="{ name: 'nouveauBesoin', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Nouveaux besoins</button>
              </router-link>

              <router-link :to="{ name: 'verificationCadrage', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Vérification cadrage</button>
              </router-link>

              <router-link :to="{ name: 'arbitragePta', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Arbitrage PTA</button>
              </router-link>

              <router-link :to="{ name: 'validationPta', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Validation PTA</button>
              </router-link>

              <router-link :to="{ name: 'declarationMarche', params: { annee: payload?.exercice?.annee } }">
                <button class="btn btn-primary">Déclaration Marché</button>
              </router-link>
            </div>

          </div>
        </div>

        <div class="card" v-if="allActionsGrouped.length > 0">
          <div class="card-header">
            <h3 class="card-title fw-bold">{{ $t('label.arbitragePta.ptaTable') }} {{ payload.exercice.annee }}
            </h3>
          </div>
          <div class="card-body">
            <div class="my-2">
              <button class="btn btn-primary text-start" @click="toggleAll">
                <span :class="allExpanded ? 'fe fe-minus' : 'fe fe-plus'"></span>
                {{ allExpanded ? 'Replier' : 'Déplier' }}
              </button>
              <p class="text-end">(En miliers FCFA TTC)</p>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered text-nowrap mb-0">
                    <thead class="border-top success02">
                      <tr>
                        <th></th>
                        <th>ID PTA interne</th>
                        <th>Description</th>
                        <th>Date Début</th>
                        <th>Date Fin</th>
                        <th>Besoin AE</th>
                        <th>Besoin CP</th>
                        <th>Report</th>

                        <th>Action</th>
                      </tr>
                    </thead>



                    <template v-for="(action, aIndex) in allActionsGrouped">
                      <tbody :key="'a-' + aIndex">
                        <tr class="bg-primary-transparent" style="cursor: pointer;"
                          @click="toggleCollapse('action', aIndex)">
                          <td class="ps-1">
                            <i :class="isCollapsed('action', aIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                            {{ action.libelleAction }}
                          </td>
                          <td colspan="10"></td>
                        </tr>
                      </tbody>


                      <tbody v-show="isCollapsed('action', aIndex)" v-for="(projet, pIndex) in action.projetPags"
                        :key="'p-' + aIndex + '-' + pIndex">
                        <tr class="bg-secondary-transparent " style="cursor: pointer;"
                          @click.stop="toggleCollapse('projet', aIndex + '-' + pIndex)">
                          <td class="ps-7 ">
                            <i :class="isCollapsed('projet', aIndex + '-' + pIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                            {{ projet.nomProjetPag }}
                          </td>
                          <td colspan="10"></td>
                        </tr>


                        <template v-if="isCollapsed('projet', aIndex + '-' + pIndex)">
                          <template v-for="(dc, actIndex) in projet.detailsComposantes">
                            <tr class="bg-success-transparent" :key="'act-' + aIndex + '-' + pIndex + '-' + actIndex"
                              style="cursor: pointer;"
                              @click.stop="toggleCollapse('activite', aIndex + '-' + pIndex + '-' + actIndex)">
                              <td class="text-center">
                                <div class="g-2">

                                  <button class="btn text-primary btn-sm" @click.prevent="doAction(dc.activite)"
                                    data-bs-toggle="tooltip" title="Suivi complet"
                                    data-bs-original-title="Suivi complet"><span class="fe fe-file-text fs-18"></span>
                                    Suivi complet</button>

                                  <!--                                  <router-link-->
                                  <!--                                      :to="{ name: 'arbitragePtaProcess', params: { id: dc.activite?.id } }"-->
                                  <!--                                      class="btn text-primary btn-sm"-->
                                  <!--                                      data-bs-toggle="tooltip"-->
                                  <!--                                      title="Suivi complet"-->
                                  <!--                                      data-bs-original-title="Suivi complet"-->
                                  <!--                                  >-->
                                  <!--                                    <span class="fe fe-file-text fs-18"></span> Suivi complet-->
                                  <!--                                  </router-link>-->

                                </div>
                              </td>
                              <!--                              <td class="ps-5"></td>-->
                              <td><i
                                  :class="isCollapsed('activite', aIndex + '-' + pIndex + '-' + actIndex) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                                {{ dc.activite.idPtaAsin }}
                              </td>
                              <td class="ps-1">{{ dc.activite.description }}</td>
                              <td>{{ formatDate(dc.activite.dateDebut) }}</td>
                              <td>{{ formatDate(dc.activite.dateFin) }}</td>
                              <td class="text-end">{{ dc.activite.besoinAeTotTtc.toLocaleString('fr-FR') }}</td>
                              <td class="text-end">{{ dc.activite.besoinCpTotTtc.toLocaleString('fr-FR') }}</td>
                              <td class="text-end">{{ dc.activite.reportMobiliseTot.toLocaleString('fr-FR') }}</td>

                              <td class="text-center">
                                <div class="g-2">
                                  <button class="btn text-primary btn-sm" @click.prevent="displayActivity(dc.activite)"
                                    data-bs-toggle="tooltip" title="Modifier" data-bs-original-title="Modifier"><span
                                      class="fe fe-edit fs-18"></span></button>

                                </div>
                              </td>
                            </tr>


                            <template v-if="isCollapsed('activite', aIndex + '-' + pIndex + '-' + actIndex)">
                              <tr v-for="(tache, tIndex) in dc.activite.taches"
                                :key="'t-' + aIndex + '-' + pIndex + '-' + actIndex + '-' + tIndex">
                                <td class="text-center">
                                  <div class="g-2">

                                    <button class="btn text-primary btn-sm" @click.prevent="doAction(tache)"
                                      data-bs-toggle="tooltip" title="Suivi complet"
                                      data-bs-original-title="Suivi complet"><span class="fe fe-file-text fs-18"></span>
                                      Suivi complet</button>

                                    <!--                                  <router-link-->
                                    <!--                                      :to="{ name: 'arbitragePtaProcess', params: { id: dc.activite?.id } }"-->
                                    <!--                                      class="btn text-primary btn-sm"-->
                                    <!--                                      data-bs-toggle="tooltip"-->
                                    <!--                                      title="Suivi complet"-->
                                    <!--                                      data-bs-original-title="Suivi complet"-->
                                    <!--                                  >-->
                                    <!--                                    <span class="fe fe-file-text fs-18"></span> Suivi complet-->
                                    <!--                                  </router-link>-->

                                  </div>
                                </td>
                                <td class="ps-10 text-end">{{ tache.idPtaAsin }}</td>
                                <td class="ps-7">{{ tache.description }}</td>
                                <td>{{ formatDate(tache.dateDebut) }}</td>
                                <td>{{ formatDate(tache.dateFin) }}</td>
                                <td class="text-end">{{ tache.besoinAeTotTtc.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ tache.besoinCpTotTtc.toLocaleString('fr-FR') }}</td>
                                <td class="text-end">{{ tache.reportMobiliseTot.toLocaleString('fr-FR') }}</td>

                                <td class="text-center">
                                  <div class="g-2">
                                    <button class="btn text-primary btn-sm"
                                      @click.prevent="editTask(tache, dc.activite)" data-bs-toggle="tooltip"
                                      title="Modifier" data-bs-original-title="Modifier"><span
                                        class="fe fe-edit fs-18"></span></button>

                                  </div>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </tbody>
                    </template>
                  </table>

                </div>
              </div>
            </div>


          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
import AmountInput from "../../components/AmountInput.vue";
import GenericDataTable from "../../components/GenericDataTable.vue";
import { useRoute } from 'vue-router';
import {
  retardColumns,
  retardFilterableFields,
  retardRowActions,
  livrableColumns,
  livrableFilterableFields,
  livrableRowActions,
  risqueColumns,
  risqueFilterableFields,
  risqueRowActions,
  pointDurFilterableFields,
  pointDurColumns,
  pointDurRowActions
} from '../../helpers/tables';

export default {
  name: "ArbitragePta",
  components: { GenericDataTable, AmountInput },
  data() {
    return {
      lang: lang,
      payload: { currentStep: 1, classeur: null, composante: "" },
      save: true,
      showList: true,
      choixAnnee: false,
      exercices: [],
      obStatutArbitrage: {
        idStatutArb: "0.0",
        libStatutArb: "A faire"
      },
      statutArbitrages: [],
      lesactivites: [],
      lestaches: [],
      activite: null,
      task: null,
      pta: null,
      allActionsGrouped: [],
      collapsedRows: {},
      lastRecordArbitrage: [],
      allExpanded: false,
      ////

      formComponent: null,
      modalTitle: '',
      formData: {},

      // Données de référence chargées
      typeLivrables: [],
      phaseExecutions: [],
      entiteTraitements: [],
      contacts: [],
      allPoles: [],
      allPriorities: [],
      allStatus: [],


      retardColumns,
      retardFilterableFields,
      retardRowActions,
      livrableColumns,
      livrableFilterableFields,
      livrableRowActions,
      risqueColumns,
      risqueFilterableFields,
      risqueRowActions,
      pointDurFilterableFields,
      pointDurColumns,
      pointDurRowActions,

    }
  },
  computed: {
    ...mapGetters({ items: 'generationPta' }),
    getExercices1() {
      this.$loading(true);
      this.$http.get('/exercice')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.exercices = data;
          this.$loading(false);

        });
    },
    filtersItems() {
      return this.items || [];
    },
    fr() {
      return this.lang.fr;
    }, anneeRoute() {
      return this.$route.params.annee || null;
    },
    besoinAeTotTtc() {
      const t = this.task;
      return (Number(t.besoinAeBnTtc) || 0)
        + (Number(t.besoinAeAntTtc) || 0)
        + (Number(t.besoinAePretTtc) || 0)
        + (Number(t.besoinAeBaTtc) || 0)
        + (Number(t.besoinAeDonTtc) || 0);
    },

    besoinCpTotTtc() {
      const t = this.task;
      return (Number(t.besoinCpBnTtc) || 0)
        + (Number(t.besoinCpAntTtc) || 0)
        + (Number(t.besoinCpPretTtc) || 0)
        + (Number(t.besoinCpBaTtc) || 0)
        + (Number(t.besoinCpDonTtc) || 0);
    },

    alloueAeTotTtc() {
      const t = this.task;
      return (Number(t.alloueAeBnTtc) || 0)
        + (Number(t.alloueAeAnTtc) || 0)
        + (Number(t.alloueAePretTtc) || 0)
        + (Number(t.alloueAeBaTtc) || 0)
        + (Number(t.alloueAeDonTtc) || 0);
    },

    alloueCpTotTtc() {
      const t = this.task;
      return (Number(t.alloueCpBnTtc) || 0)
        + (Number(t.alloueCpAnTtc) || 0)
        + (Number(t.alloueCpPretTtc) || 0)
        + (Number(t.alloueCpBaTtc) || 0)
        + (Number(t.alloueCpDonTtc) || 0);
    },
    reportMobiliseTot() {
      const t = this.task;
      const bn = Number(t.reportBnTtc) || 0;
      const pret = Number(t.reportPretTtc) || 0;
      const ant = Number(t.reportAntTtc) || 0;
      const ba = Number(t.reportBaTtc) || 0;
      const don = Number(t.reportDonTtc) || 0;

      console.log('Recomputing total:', t.reportBnTtc, t.reportPretTtc);

      return bn + pret + ant + ba + don;
    },
  },
  watch: {
  },
  mounted() {
    this.loadAllData();
  },
  methods: {
    ...mapActions('generationPta', ['all', 'add']),
    async reloadModalData(task) {
      this.$loading(true);
      const { data } = await this.$http.get(`/pta/parent/all/${task.idDetailParent}`);
      this.lestaches = data;

      const { data: activ } = await this.$http.get(`/pta/${task.idActivite}`);
      this.activite = activ;

      this.loadActionsGrouped();


    }, async loadAllData() {
      this.$loading(true);
      try {
        await Promise.all([
          this.loadTypeLivrables(),
          this.getPhaseExecutions(),
          this.getEntiteTraitements(),
          this.getAllContacts(),
          this.getAllPoles(),
          this.getallPriorities(),
          this.getallStatuts()
        ]);
      } catch (err) {
        console.error("Erreur chargement données complémentaires :", err);
      }
      this.$loading(false);
    },
    loadTypeLivrables() {
      return this.$http.get('/typeLivrables').then(({ data }) => {
        this.typeLivrables = data;
      });
    }, getPhaseExecutions() {
      return this.$http.get('/phaseExecution').then(({ data }) => {
        this.phaseExecutions = data;
      });
    },
    getEntiteTraitements() {
      return this.$http.get('/entiteTraitement').then(({ data }) => {
        this.entiteTraitements = data;
      });
    },
    getAllContacts() {
      return this.$http.get('/contacts').then(({ data }) => {
        this.contacts = data;
      });
    },
    getAllPoles() {
      return this.$http.get('/poleAsin').then(({ data }) => {
        this.allPoles = data;
      });
    },
    getallPriorities() {
      return this.$http.get('/priorite').then(({ data }) => {
        this.allPriorities = data;
      });
    },
    getallStatuts() {
      return this.$http.get('/statutGenerique').then(({ data }) => {
        this.allStatus = data;
      });
    },
    toggleCollapse(type, index) {
      const key = `${type}-${index}`;
      this.$set(this.collapsedRows, key, !this.collapsedRows[key]);
    },
    isCollapsed(type, index) {
      const key = `${type}-${index}`;
      return this.collapsedRows[key];
    },
    toggleAll() {
      this.allExpanded = !this.allExpanded;

      this.allActionsGrouped.forEach((action, aIndex) => {
        const actionKey = `action-${aIndex}`;
        this.$set(this.collapsedRows, actionKey, this.allExpanded);

        action.projetPags.forEach((projet, pIndex) => {
          const projetKey = `projet-${aIndex + '-' + pIndex}`;
          this.$set(this.collapsedRows, projetKey, this.allExpanded);

          projet.detailsComposantes.forEach((activite, actIndex) => {
            const activiteKey = `activite-${aIndex + '-' + pIndex + '-' + actIndex}`;
            this.$set(this.collapsedRows, activiteKey, this.allExpanded);
          });

        });


      });
    },
    async displayActivity(item) {
      this.$loading(true);

      try {

        await this.getPta(item.id, "activite");
        await this.getAllPtaByDetailComposant(item.idDetail);
        $('#modal-detail-activity').modal('show');
      } catch (error) {
        console.error('Erreur dans displayActivity:', error);
      } finally {
        this.$loading(false);
      }
    },



    isEmpty(value) {
      return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    isValidMontants() {
      const totalAlloueAe = this.alloueAeTotTtc;
      const totalAlloueCp = this.alloueCpTotTtc;
      const totalBesoinCp = this.besoinCpTotTtc;
      const totalBesoinAe = this.besoinAeTotTtc;

      const allPositive = totalAlloueAe >= 0 && totalAlloueCp >= 0 && totalBesoinAe >= 0 && totalBesoinCp >= 0;

      return allPositive > 0;
    },



    getExercices() {
      this.$loading(true);
      this.$http.get('/exercice')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.exercices = data;
          this.$loading(false);

        });
    },

    async getExercices() {
      this.$loading(true);
      this.$http.get('/exercice')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.exercices = data;
          this.$loading(false);

        });
    },

    loadActionsGrouped() {
      this.$loading(true);
      this.$http.get(`/search/actions/${this.payload.exercice.annee}`)
        .then(({ data }) => {
          console.log(data);
          this.choixAnnee = true;
          this.allActionsGrouped = data;
          this.$loading(false);
        });
    },
    formatDate(dateStr, mode = 'court') {
      const date = new Date(dateStr);

      const optionsLong = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };

      const optionsCourt = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      };

      const options = mode === 'long' ? optionsLong : optionsCourt;

      return date.toLocaleString('fr-FR', options);
    }
    ,    getStatutArbitrage() {
      this.$http.get('/statutArbitrage')
        .then(({ data }) => {
          console.log(data);
          console.log(1);
          this.statutArbitrages = data;

        });
    },

  },
  created() {
    
    this.getExercices()
    this.getStatutArbitrage()

    this.payload.exercice = this.exercices.find(e => e.annee == this.anneeRoute) || null;
    console.log(this.exercices)
    
    if(this.anneeRoute){
        this.$loading(true);
        this.$http.get(`/search/actions/${this.anneeRoute}`)
        .then(({ data }) => {
          console.log(data);
          this.choixAnnee = true;
          this.allActionsGrouped = data;
          this.$loading(false);
           this.payload.exercice = this.exercices.find(e => e.annee == this.anneeRoute) || null;
        });
    }


  },
}
</script>

<style>
.loading-screen {
  z-index: 9999999999999 !important;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>